"use client";

import { createContext, type ReactNode, useContext } from "react";

export type TestSource =
  | { kind: "studyset"; studySetId: string }
  | { kind: "folder"; folderId: string };

const TestSourceContext = createContext<TestSource | null>(null);

export function TestSourceProvider({
  source,
  children,
}: {
  source: TestSource;
  children: ReactNode;
}) {
  return (
    <TestSourceContext.Provider value={source}>
      {children}
    </TestSourceContext.Provider>
  );
}

export function useTestSource() {
  const source = useContext(TestSourceContext);
  if (!source) throw new Error("useTestSource outside TestSourceProvider");
  return source;
}

export function sourceInput(source: TestSource) {
  return source.kind === "studyset"
    ? { studySetId: source.studySetId }
    : { folderId: source.folderId };
}

export function sourceBasePath(source: TestSource) {
  return source.kind === "studyset"
    ? `/studysets/${source.studySetId}`
    : `/folders/${source.folderId}`;
}
